/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import {
  SiteNameLabel,
  SiteUrlWrapper,
  SiteUrlTextWrapper,
  ActionsWrapper,
  MobileModal,
} from "./productPreviewModalStyles.js";

import ClipBoardButton from "../reusableComponents/Button/ClipBoardButton.js";

export function ProductPreviewModal(props) {
  const { isMobile = false } = props;
  

  return (
    <MobileModal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={isMobile ? false : true}
    >
      <Modal.Header closeButton className="custom-modal-header">
        <Modal.Title id="contained-modal-title-vcenter">
          Select a Site
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.previewurls &&
          props.previewurls.map((site) => {
            return (
              <div
                key={`${site.SiteId}${site.siteName}`}
                style={{ marginBottom: "2rem" }}
              >
                <SiteNameLabel>{site.siteType}</SiteNameLabel>
                <SiteUrlWrapper>
                  <SiteUrlTextWrapper>
                    <input
                      style={{ width: "99%", height: "99%" }}
                      type="text"
                      value={site.previewUrl}
                      readOnly
                    />
                  </SiteUrlTextWrapper>
                  <ActionsWrapper>
                
                    <ClipBoardButton
                      type="secondary"
                      label="Copy URL"
                      text={site.previewUrl}
                      clickHandler={() => console.log(site.previewUrl)}
                    />
                   
                    <ClipBoardButton
                      label="View"
                      clickHandler={() =>
                        window.open(site.previewUrl, "_blank")
                      }
                    />                  
                  </ActionsWrapper>
                </SiteUrlWrapper>
              </div>
            );
          })}
      </Modal.Body>
    </MobileModal>
  );
}

ProductPreviewModal.propTypes = {
  isMobile: PropTypes.bool,
  previewurls: PropTypes.arrayOf(
    PropTypes.shape({
      previewUrl: PropTypes.string.isRequired,
      siteId: PropTypes.number.isRequired,
      siteName: PropTypes.string.isRequired,
      siteType: PropTypes.string.isRequired,
    })
  ),
};
